import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import '../../components/css/join_us.css'
import njangieImage from "../../assets/static/njangie.webp";

const NjangieHome = () => {
  return (
   <Container fluid className="bg-custom px-0">
  <Container className="container-padding px-0 px-md-3">
    
    <Row className="flex-column flex-md-row mx-0">
      
      <Col md={6} className="d-flex align-items-start order-md-2 px-0 px-md-3">
        <div className="images w-100">
          <img 
            src={njangieImage} 
            alt="Sample" 
            className="img-fluid w-100" 
            style={{ maxWidth: '90%' }}
          />
        </div>
      </Col>

      <Col md={6} className="d-flex align-items-start order-md-1 px-2 px-md-3">
        <div className="content">
          <h2>Njangie Group Experience</h2>
          <h1>Njangie is the Right Choice for Your Financial Discipline</h1>
          <p>
            Njangie is a traditional African savings group where members contribute a fixed amount of money regularly, 
            and each member receives the total sum in turns.
          </p>
          <ul className="bullet-points">
            <li><strong>Why Kontriman Njangie:</strong></li>
            <li>Financial Discipline</li>
            <li>Community Support</li>
            <li>Loan Access</li>
            <li>Empowerment</li>
            <li>Trust Building</li>
          </ul>
          <a href="/njangie">
            <Button className="mt-3 custom-button">
              Discover more on Njangie
            </Button>
          </a>
        </div>
      </Col>

    </Row>

  </Container>
</Container>
  );
}

export default NjangieHome;
